import React from 'react';
import { CommentSection, RatingCard, DoughnutGraph } from '../../organisms';
import {
  doctor,
  instant_chat,
  phone_clock,
  timebgyellow,
  waittime,
  male_circle,
  healthCheckMale,
} from '../../../../assets/images';
import { MetricCard } from '../../atoms';
import { commaingNumber } from '../../../../utils';

const DoctorConsultation = ({ metricObj, usersObj, ratingObj, coverageObj, loading }) => {
  const {
    consultation_completed,
    total_chat_consultation,
    total_call_consultation,
    total_consultation_time,
    average_consultation_time,
    average_wait_time,
  } = metricObj;

  const { unique_users, repeat_users, total_customers } = usersObj;
  const { ratingsPercent, totalratings, averagerating, commentSectionData } = ratingObj;

  const { donutGraphData } = coverageObj;
  return (
    <div>
      <p className='text-gray-700 text-base font-semibold mt-8 mb-3 leading-none'>Total Consultations</p>
      <div className='flex flex-row justify-between'>
        <MetricCard
          loading={loading}
          loaderHeight={120}
          svgsrc={doctor}
          title='Total consultations'
          metricValue={
            <span className='font-semibold text-3xl text-gray-700'>{commaingNumber(consultation_completed)}</span>
          }
          classes='w-1/3 inline-block mr-5'
        />
        <MetricCard
          loading={loading}
          loaderHeight={120}
          svgsrc={instant_chat}
          title='Total chat consultations'
          metricValue={
            <span className=' font-semibold  text-3xl text-gray-700'>{commaingNumber(total_chat_consultation)}</span>
          }
          classes='w-1/3 inline-block mr-5'
        />
        <MetricCard
          loading={loading}
          loaderHeight={120}
          svgsrc={phone_clock}
          title='Total call consultations'
          metricValue={
            <span className=' font-semibold  text-3xl text-gray-700'>{commaingNumber(total_call_consultation)}</span>
          }
          classes='w-1/3 inline-block'
        />
      </div>

      <p className='text-gray-700 text-base font-semibold mt-12 mb-3 leading-none'>Consultation duration</p>
      <div className='flex flex-row justify-between'>
        <MetricCard
          loading={loading}
          loaderHeight={120}
          svgsrc={timebgyellow}
          title='Total consultation time'
          metricValue={
            <span className='font-semibold text-3xl text-gray-700'>
              {commaingNumber(parseInt(total_consultation_time, 10))}
            </span>
          }
          metricValueSuffix='minutes'
          classes='w-1/3 inline-block mr-5'
        />
        <MetricCard
          loading={loading}
          loaderHeight={120}
          svgsrc={timebgyellow}
          title='Average consultation time'
          metricValue={
            <span className='font-semibold text-3xl text-gray-700'>{commaingNumber(average_consultation_time)}</span>
          }
          metricValueSuffix='minutes'
          classes='w-1/3 inline-block mr-5'
        />
        <MetricCard
          loading={loading}
          loaderHeight={120}
          svgsrc={waittime}
          title='Average wait time'
          metricValue={
            <span className=' font-semibold  text-3xl text-gray-700'>{commaingNumber(average_wait_time)}</span>
          }
          metricValueSuffix='seconds'
          classes='w-1/3 inline-block'
        />
      </div>

      <div className='flex flex-row mt-12'>
        <div className='flex flex-col w-2/4 pr-4'>
          <div className='text-base font-semibold leading-2 text-gray-700 leading-none mb-1'>Ratings and Reviews</div>
          <div className='text-sm mb-3 leading-2 text-gray-600'>
            These ratings are captured after completing the consultations.
          </div>
          <RatingCard
            loading={loading}
            loaderHeight={200}
            rating={averagerating}
            number_of_ratings={totalratings}
            five_star_rating={ratingsPercent && ratingsPercent[4]}
            four_star_rating={ratingsPercent && ratingsPercent[3]}
            three_star_rating={ratingsPercent && ratingsPercent[2]}
            two_star_rating={ratingsPercent && ratingsPercent[1]}
            one_star_rating={ratingsPercent && ratingsPercent[0]}
            classes='h-full'
          />
        </div>

        <div className='w-2/4 flex flex-col'>
          <div className='text-base font-semibold leading-2 text-gray-700 leading-none mb-1'>Top Comments</div>
          <div className='text-sm mb-3 leading-2 text-gray-600'>
            These reviews are captured after completing the consultations.
          </div>
          <CommentSection loading={loading} loaderHeight={200} points={commentSectionData} classes='h-full' />
        </div>
      </div>

      <div className='flex flex-row mt-12'>
        <div className='w-2/4 pr-4'>
          <div className='text-base font-semibold leading-2 text-gray-700 mb-3 leading-none'>
            Unique users vs Repeat users
          </div>
          <MetricCard
            loading={loading}
            loaderHeight={120}
            svgsrc={healthCheckMale}
            title='Unique users (Employees who took doctor consultation only once)'
            metricValue={<span className='font-semibold text-3xl text-gray-700'>{commaingNumber(unique_users)}</span>}
            metricValueSuffix={`${total_customers ? Math.round((unique_users / total_customers) * 100):0}% of active employees`}
            classes='mb-3'
          />
          <MetricCard
            loading={loading}
            loaderHeight={120}
            svgsrc={male_circle}
            title='Repeat users (Employees who took doctor consultation more than once)'
            metricValue={<span className='font-semibold text-3xl text-gray-700'>{commaingNumber(repeat_users)}</span>}
            metricValueSuffix={`${total_customers ? Math.round((repeat_users / total_customers) * 100):0}% of active employees`}
          />
        </div>

        <div className='flex flex-col w-2/4'>
          <div className='text-base font-semibold leading-2 text-gray-700 mb-3 leading-none'>Consultation coverage</div>
          <DoughnutGraph
            loading={loading}
            loaderHeight={255}
            title={'Consultations'}
            graphData={donutGraphData}
            tooltip_placement='top'
            classes='h-full'
            id={'doctor_consultation'}
          />
        </div>
      </div>
    </div>
  );
};

export default DoctorConsultation;
